module.exports = __webpack_public_path__ + "img/item12.78ec0205.png";